import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { SubscriberType } from './subscriber-type';
import { SignatureType } from './signature-type';
import { take, map } from 'rxjs/operators';

export class TableSignUserBase {

  public signatureType: SignatureType;
  public subscriberType: SubscriberType;

  constructor(public translate: TranslateService) {

  }

  createInitObject(): Observable<any> {
    this.subscriberType = new SubscriberType(this.translate);
    this.signatureType = new SignatureType(this.translate);

    return this.subscriberType.Init().pipe(take(1), map(() => this.signatureType.Init()));
  }
}
